import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { NLPSearchErrorState, NLPSearchResultFormat } from '../../../ai-answer-dialog/types';
import { fetchAggResponse } from '../../../common/fetch';
import { sanitizeAndMapRecentWorkActivity, trimARI } from '../../util';
import { KNOWLEDGE_CARD_TEAM_DATA_OPERATION_NAME, KNOWLEDGE_CARD_TEAM_SEARCH_OPERATION_NAME, KNOWLEDGE_CARD_TEAM_SEARCH_RELEVANCE_OPERATION_NAME, KnowledgeCardTeamDataQuery, KnowledgeCardTeamSearchQuery, KnowledgeCardTeamSearchRelevanceQuery } from './gql';
var NO_TEAM_MESSAGE = 'NO_TEAM';
export var noTeamResult = {
  team_metadata: {
    id: '',
    name: '',
    avatarUrl: null,
    url: null,
    memberCount: 0,
    members: [],
    recentActivity: []
  }
};
export var fetchTeamKnowledgeCardDataWithRanking = function fetchTeamKnowledgeCardDataWithRanking(_ref) {
  var activityClient = _ref.activityClient,
    teamQuery = _ref.teamQuery,
    orgId = _ref.orgId,
    siteId = _ref.siteId,
    sourceProduct = _ref.sourceProduct;
  var teamResult;
  var teamData;
  var activityResult;
  var siteARI = sourceProduct ? "ari:cloud:".concat(sourceProduct, "::site/").concat(siteId) : '';
  var actors = [];
  return fetchAggResponse({
    graphQuery: KnowledgeCardTeamSearchRelevanceQuery,
    variables: {
      teamQuery: teamQuery,
      orgId: orgId,
      siteId: siteARI
    },
    operationName: KNOWLEDGE_CARD_TEAM_SEARCH_RELEVANCE_OPERATION_NAME
  }).then(function (_ref2) {
    var _data$knowledgeDiscov;
    var data = _ref2.data,
      errors = _ref2.errors;
    var id = data === null || data === void 0 || (_data$knowledgeDiscov = data.knowledgeDiscovery.searchTeam) === null || _data$knowledgeDiscov === void 0 ? void 0 : _data$knowledgeDiscov.id;
    if (!errors && id) {
      teamResult = id;
    } else {
      throw new Error(NO_TEAM_MESSAGE);
    }
    return fetchAggResponse({
      graphQuery: KnowledgeCardTeamDataQuery,
      variables: {
        teamId: teamResult,
        siteId: siteId
      },
      operationName: KNOWLEDGE_CARD_TEAM_DATA_OPERATION_NAME
    });
  }).then(function (_ref3) {
    var _data$team$teamV, _teamData$team$teamV;
    var data = _ref3.data,
      errors = _ref3.errors;
    if (!errors && data !== null && data !== void 0 && (_data$team$teamV = data.team.teamV2) !== null && _data$team$teamV !== void 0 && _data$team$teamV.id) {
      teamData = data;
    } else {
      throw new Error(NO_TEAM_MESSAGE);
    }
    actors = ((_teamData$team$teamV = teamData.team.teamV2) === null || _teamData$team$teamV === void 0 || (_teamData$team$teamV = _teamData$team$teamV.members) === null || _teamData$team$teamV === void 0 || (_teamData$team$teamV = _teamData$team$teamV.nodes) === null || _teamData$team$teamV === void 0 ? void 0 : _teamData$team$teamV.map(function (node) {
      return node.member ? node.member.id : '';
    }).filter(function (member) {
      return !!member;
    })) || [];
    return activityClient.fetchActivities([100], {
      limit: 100,
      actors: actors,
      rootContainerIds: ["ari:cloud:platform::site/".concat(siteId)]
    }, ['workedOn'], false);
  }).then(function (data) {
    var _teamData, _teamData2, _teamData3, _teamData4, _teamData5, _teamData6, _teamData7;
    if (data.workedOn && data.workedOn.length > 0) {
      activityResult = data.workedOn;
    }
    var filteredActivityResult = filterTeamActivities(activityResult || [], actors);
    var finalResult = {
      team_metadata: {
        id: ((_teamData = teamData) === null || _teamData === void 0 || (_teamData = _teamData.team.teamV2) === null || _teamData === void 0 ? void 0 : _teamData.id) || '',
        name: ((_teamData2 = teamData) === null || _teamData2 === void 0 || (_teamData2 = _teamData2.team.teamV2) === null || _teamData2 === void 0 ? void 0 : _teamData2.displayName) || '',
        avatarUrl: ((_teamData3 = teamData) === null || _teamData3 === void 0 || (_teamData3 = _teamData3.team.teamV2) === null || _teamData3 === void 0 ? void 0 : _teamData3.smallAvatarImageUrl) || null,
        url: (_teamData4 = teamData) !== null && _teamData4 !== void 0 && (_teamData4 = _teamData4.team.teamV2) !== null && _teamData4 !== void 0 && _teamData4.id ? "/people/team/".concat(trimARI((_teamData5 = teamData) === null || _teamData5 === void 0 || (_teamData5 = _teamData5.team.teamV2) === null || _teamData5 === void 0 ? void 0 : _teamData5.id)) : null,
        memberCount: ((_teamData6 = teamData) === null || _teamData6 === void 0 || (_teamData6 = _teamData6.team.teamV2) === null || _teamData6 === void 0 ? void 0 : _teamData6.members.nodes.length) || 0,
        members: (_teamData7 = teamData) !== null && _teamData7 !== void 0 && (_teamData7 = _teamData7.team.teamV2) !== null && _teamData7 !== void 0 && (_teamData7 = _teamData7.members) !== null && _teamData7 !== void 0 && _teamData7.nodes ? sanitizeAndMapTeamMembers(teamData.team.teamV2.members.nodes) : [],
        recentActivity: filteredActivityResult ? sanitizeAndMapRecentWorkActivity(filteredActivityResult) : []
      }
    };
    return {
      nlpSearch: {
        nlpResult: JSON.stringify(finalResult),
        uniqueSources: [],
        disclaimer: null,
        errorState: null,
        format: NLPSearchResultFormat.JSON
      }
    };
  }).catch(function (error) {
    if (error instanceof Object && 'message' in error && error.message === NO_TEAM_MESSAGE) {
      return {
        nlpSearch: {
          nlpResult: JSON.stringify(noTeamResult),
          errorState: null,
          disclaimer: null,
          format: NLPSearchResultFormat.JSON,
          uniqueSources: []
        }
      };
    }
    return Promise.reject(error);
  });
};
export var fetchTeamKnowledgeCardData = function fetchTeamKnowledgeCardData(_ref4) {
  var activityClient = _ref4.activityClient,
    teamQuery = _ref4.teamQuery,
    orgId = _ref4.orgId,
    tenantId = _ref4.tenantId;
  var teamResult;
  var activityResult;
  var onError = function onError(error) {
    return Promise.reject(error);
  };
  try {
    var actors = [];
    return fetchAggResponse({
      graphQuery: KnowledgeCardTeamSearchQuery,
      variables: {
        teamQuery: teamQuery,
        orgId: "ari:cloud:platform::org/".concat(orgId),
        tenantId: tenantId
      },
      operationName: KNOWLEDGE_CARD_TEAM_SEARCH_OPERATION_NAME
    }).then(function (_ref5) {
      var _teamResult;
      var data = _ref5.data,
        errors = _ref5.errors;
      if (!errors && data !== null && data !== void 0 && data.team.teamSearchV2.nodes && data.team.teamSearchV2.nodes.length > 0 && data.team.teamSearchV2.nodes[0]) {
        teamResult = data.team.teamSearchV2.nodes[0];
      } else {
        throw new Error('No team found');
      }
      actors = ((_teamResult = teamResult) === null || _teamResult === void 0 || (_teamResult = _teamResult.team) === null || _teamResult === void 0 || (_teamResult = _teamResult.members) === null || _teamResult === void 0 || (_teamResult = _teamResult.nodes) === null || _teamResult === void 0 ? void 0 : _teamResult.map(function (node) {
        return node.member ? node.member.id : '';
      }).filter(function (member) {
        return !!member;
      })) || [];
      return activityClient.fetchActivities([100], {
        limit: 100,
        actors: actors,
        rootContainerIds: ["ari:cloud:platform::site/".concat(tenantId)]
      }, ['workedOn'], false);
    }, onError).then(function (data) {
      var _teamResult2, _teamResult3, _teamResult4, _teamResult5, _teamResult6, _teamResult7;
      if (data.workedOn && data.workedOn.length > 0) {
        activityResult = data.workedOn;
      }
      var filteredActivityResult = filterTeamActivities(activityResult || [], actors);
      var finalResult = {
        team_metadata: {
          id: ((_teamResult2 = teamResult) === null || _teamResult2 === void 0 || (_teamResult2 = _teamResult2.team) === null || _teamResult2 === void 0 ? void 0 : _teamResult2.id) || '',
          name: ((_teamResult3 = teamResult) === null || _teamResult3 === void 0 || (_teamResult3 = _teamResult3.team) === null || _teamResult3 === void 0 ? void 0 : _teamResult3.displayName) || '',
          avatarUrl: ((_teamResult4 = teamResult) === null || _teamResult4 === void 0 || (_teamResult4 = _teamResult4.team) === null || _teamResult4 === void 0 ? void 0 : _teamResult4.smallAvatarImageUrl) || null,
          url: (_teamResult5 = teamResult) !== null && _teamResult5 !== void 0 && (_teamResult5 = _teamResult5.team) !== null && _teamResult5 !== void 0 && _teamResult5.id ? "/people/team/".concat(trimARI(teamResult.team.id)) : null,
          memberCount: ((_teamResult6 = teamResult) === null || _teamResult6 === void 0 ? void 0 : _teamResult6.memberCount) || 0,
          members: (_teamResult7 = teamResult) !== null && _teamResult7 !== void 0 && (_teamResult7 = _teamResult7.team) !== null && _teamResult7 !== void 0 && (_teamResult7 = _teamResult7.members) !== null && _teamResult7 !== void 0 && _teamResult7.nodes ? sanitizeAndMapTeamMembers(teamResult.team.members.nodes) : [],
          recentActivity: filteredActivityResult ? sanitizeAndMapRecentWorkActivity(filteredActivityResult) : []
        }
      };
      return {
        nlpSearch: {
          nlpResult: JSON.stringify(finalResult),
          uniqueSources: [],
          disclaimer: null,
          errorState: null,
          format: NLPSearchResultFormat.JSON
        }
      };
    }, onError);
  } catch (error) {
    return Promise.resolve({
      nlpSearch: {
        errorState: NLPSearchErrorState.NetworkError,
        disclaimer: null,
        format: NLPSearchResultFormat.JSON,
        uniqueSources: []
      }
    });
  }
};
var sanitizeAndMapTeamMembers = function sanitizeAndMapTeamMembers(members) {
  return members.reduce(function (result, memberNode) {
    if (!!memberNode.member) {
      var _memberNode$member$ex, _memberNode$member$ex2;
      return result.concat({
        name: memberNode.member.name || '',
        picture: memberNode.member.picture || null,
        title: ((_memberNode$member$ex = memberNode.member.extendedProfile) === null || _memberNode$member$ex === void 0 ? void 0 : _memberNode$member$ex.jobTitle) || null,
        url: !!memberNode.member.id ? "/people/".concat(trimARI(memberNode.member.id)) : null,
        accountId: !!memberNode.member.id ? trimARI(memberNode.member.id) : null,
        department: ((_memberNode$member$ex2 = memberNode.member.extendedProfile) === null || _memberNode$member$ex2 === void 0 ? void 0 : _memberNode$member$ex2.department) || null,
        email: memberNode.member.email || null
      });
    }
    return result;
  }, []);
};
var excludedEventTypes = ['commented', 'updated'];
export var filterTeamActivities = function filterTeamActivities(activityResult, members) {
  var teamMemberSet = new Set(members);
  return activityResult.reduce(function (filtered, activity) {
    var involvedTeamMembers = activity.contributors.filter(function (contributor) {
      return teamMemberSet.has("ari:cloud:identity::user/".concat(contributor.accountId));
    });
    if (involvedTeamMembers.length >= 1 && !excludedEventTypes.includes(activity.eventType)) {
      filtered.push(_objectSpread(_objectSpread({}, activity), {}, {
        contributors: involvedTeamMembers
      }));
    }
    return filtered;
  }, []);
};